// The function was taken from the fareharbor application
export const prepareInterpolateFunction = (originInterpolate) => {
  const djangoJsInterpolate = originInterpolate;

  const interpolate = (...args) => {
    if (args.length === 2) {
      // Infer whether to use named or positional interpolation.
      const newArgs = [];
      for (let i = 0; i < args.length; i += 1) {
        newArgs.push(args[i]);
      }
      newArgs.push(!Array.isArray(newArgs[1]));
      return djangoJsInterpolate.apply(this, newArgs);
    }

    return djangoJsInterpolate.apply(this, args);
  };
  window.interpolate = interpolate;
};

// It's fallback if translations weren't loaded
export const mockTranslationFunctions = () => {
  window.T = (str) => str;
  window.cT = (_str, abbreviation) => abbreviation;
  window.nT = (str) => str;

  // The function was taken from the fareharbor application
  window.interpolate = (fmt, obj, named) => {
    if (named) {
      return fmt.replace(/%\(\w+\)s/g, (match) =>
        String(obj[match.slice(2, -2)]),
      );
    }
    return fmt.replace(/%s/g, () => String(obj.shift()));
  };
};
